export const blockIconsHouseholdThermometerNew = (
	<span className='material-symbols-outlined'>thermometer</span>
);
